import axios from '@/axios/fetch';
import useUserHooks from '@/hooks/user.hooks';
import { PageRequest } from '@/interface/index.interface';
import { obj2form } from '@/lib';
import { definitions } from '@/types/api';
/** report.services 实验报告 */
const reportService = () => {
  const userHooks = useUserHooks();
  /**
   * 学生端-查询实验报告
   * @param experimentId 分配实验id
   */
  const queryExperimentReport = async (experimentId: string, stuCode?: string): Promise<definitions['ExperimentOperatingResponse']> => {
    const userId = stuCode || userHooks.getUserInfo().code;
    const { data } = await axios.post(`api/experimentOperating/queryExperimentReport/${experimentId}/${userId}`);
    return data.data;
  };

  /**
   * 学生端-查询实验报告列表
   */
  const listExperimentReportList = async (param: definitions['PageQueryRequest']): Promise<Required<definitions['Page«Experiment»']>> => {
    const { data } = await axios.post('./api/experiment/queryExperimentByUserId', param);
    return data.data;
  };

  /**
   * 教师端-根据教师code查询所有实验列表
   */
  const listExperimentByTeacher = async (param: PageRequest<{}>): Promise<Required<definitions['Page«Experiment»']>> => {
    const { data } = await axios.post('./api/experiment/queryExperimentByTeacher', obj2form({
      ...param,
      teacher: userHooks.getUserInfo().code,
    }));
    return data.data;
  };

  /** 教师端-根据实验id-下载报告 */
  const queryExperimentExcel = async (experimentId: string) => {
    const { data } = await axios.post(`./api/experiment/downLoadScoreExcel/${experimentId}`);
    return data.data;
  };

  /**
   * 教师端-根据实验id，查询该实验数据
   */
  const queryExperimentInfoById = async (experimentId: string): Promise<definitions['Experiment']> => {
    const { data } = await axios.post(`./api/experiment/getExperimentById/${experimentId}`);
    return data.data;
  };

  /**
   * 教师端-根据实验id，查询实验报告-成员列表页
   */
  const listExperimentMember = async (param: PageRequest<{experimentId: string}>): Promise<Required<definitions['Page«ExperimentScorePersonnelResponse»']>> => {
    const { data } = await axios.post('./api/experimentScore/queryExperimentScoreByExperimentId', param);
    return data.data;
  };

  return {
    queryExperimentReport,
    listExperimentReportList,
    listExperimentByTeacher,
    queryExperimentExcel,
    queryExperimentInfoById,
    listExperimentMember,
  };
};

export default reportService;
